import { type Icon, Info } from "@phosphor-icons/react";
import clsx from "clsx";

import RenderIf from "common/components/RenderIf";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

import type React from "react";

interface ItemContainerProps {
  icon: Icon;
  title: string;
  description: string;
  children: React.ReactNode;
  isDrip: boolean;
  infoText?: string;
}

export default function ItemContainer({
  icon: Icon,
  title,
  description,
  children,
  isDrip,
  infoText = "",
}: ItemContainerProps) {
  return (
    <section className="flex flex-col justify-between gap-3 py-4 lg:flex-row lg:items-center">
      <div className="flex gap-x-2.5">
        <span
          className={clsx(
            "inline-flex size-10 shrink-0 items-center justify-center rounded-2xl",
            isDrip ? "bg-blue-100 text-blue-600" : "bg-black-100",
          )}
        >
          <Icon size={20} />
        </span>

        <div className="flex flex-col gap-0.5">
          <div className="flex gap-1">
            <h5 className="text-button-md">{title}</h5>
            <RenderIf condition={!!infoText}>
              <Tooltip>
                <TooltipTrigger>
                  <Info size={18} weight="fill" className="fill-black-300" />
                </TooltipTrigger>
                <TooltipContent>{infoText}</TooltipContent>
              </Tooltip>
            </RenderIf>
          </div>
          <p className="text-xs text-black-500">{description}</p>
        </div>
      </div>

      {children}
    </section>
  );
}
